import { useQuery } from '@tanstack/react-query';

import { getUserApi } from '@/entities/user';

export const accountPageQueryKeys = {
  all: ['account'] as const,
  page: () => [...accountPageQueryKeys.all, 'page'] as const,
};

export const useUserData = (enabled = false) => {
  return useQuery({
    queryKey: accountPageQueryKeys.page(),
    queryFn: () => getUserApi(),
    placeholderData: (previousData) => previousData,
    retry: false,
    refetchOnWindowFocus: false,
    enabled,
  });
};
